import apiClient from '../../core/Api';
import { ContentQueryParams, Response } from '../../data/types/content.interface';
import { TagType } from '../../data/types/tags.interface';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class TagService {
  static getTags = async (): Promise<TagType[]> =>
    apiClient.get(`${API_BASE_URL}/tags`).then((response) => response.data);

  static getContents = async (tagName: string, params: ContentQueryParams): Promise<Response> =>
    apiClient.get(`${API_BASE_URL}/${tagName}/contents`, { params }).then((response) => {
      const { data } = response;
      return data;
    });
}

export default TagService;
